
    var riot = require('riot')
    //src: starling/src/tags/user-settings.html
riot.tag2('user-settings',
  '<div class="sidebar-content"> <div class="sidebar-header"> <h2><i class="material-icons">settings</i> Settings</h2> </div> <div class="sidebar-items sidebar-items--no-footer dynamic-shadow-scroll" onwheel="{handleScroll}"> <label class="section-label">Autocomplete from</label> <ul> <li class="wikipedia"> <label class="library-name" for="wikipedia_checkbox">Wikipedia</label> <switch name="wikipedia" checked="{user && user.settings.allowedLibraries.includes(\'1\')}" toggle="{toggleLibrary(\'1\')}"></switch> </li> <li if="{user}" class="user-library"> <label class="library-name" for="user-library_checkbox">My Ideas Library</label> <switch name="user-library" checked="{user && user.settings.allowedLibraries.includes(String(user.defaultLibraryId))}" toggle="{toggleLibrary(String(user.defaultLibraryId))}"></switch> </li> </ul> <label class="section-label">Spelling</label> <ul> <li class="spellcheck"> <label class="library-name" for="spellcheck_checkbox">Spellcheck</label> <switch name="spellcheck" checked="{user && user.settings.spellcheck}" toggle="{toggleSpellcheck}"></switch> </li> </ul> <label class="section-label">Canvas</label> <ul> <li class="semantic-zoom"> <label>Background Color <div class="info-container tip-container wrap-data-tip" data-tip="Set the default background color for your maps. Only you will see this."> <i class="material-icons tip-trigger">info</i> </div> </label> <div class="background-color_container "> <div class="color-swatch bg-white {this.selectedBgColorClass(\'white\')}" onclick="{this.handleColorClick.bind(null,\'white\')}"></div> <div class="color-swatch bg-gray1 {this.selectedBgColorClass(\'gray1\')}" onclick="{this.handleColorClick.bind(null,\'gray1\')}"></div> </div> </li> <li class="show-tips-while-loading"> <label for="show-tips-while-loading_checkbox ">Show tips while loading map <div class="info-container tip-container wrap-data-tip" data-tip="Learn about features of Plectica while you wait for your map to load"> <i class="material-icons tip-trigger">info</i> </div> </label> <switch name="toggle-show-tips" checked="{showTipsChecked()}" toggle="{toggleShowTips}"></switch> </li> </ul> <label class="section-label">Panning & Zooming</label> <ul> <li class="semantic-zoom"> <label for="semantic-zoom_checkbox">Semantic Zoom <div class="info-container tip-container wrap-data-tip" data-tip="Semantic zoom makes it easier to see high level items when you zoom out."> <i class="material-icons tip-trigger">info</i> </div> </label> <switch name="semantic-zoom" checked="{user && user.settings.semantic_zoom}" toggle="{toggleSemanticZoom}"></switch> </li> <li class="scroll-to-pan"> <label for="scroll-to-pan_checkbox">Scroll to pan <div class="info-container tip-container wrap-data-tip" data-tip="Scroll to move around your map on this computer. Press control and scroll to zoom."> <i class="material-icons tip-trigger">info</i> </div> </label> <switch name="scroll-to-pan" checked="{scrollToPanChecked()}" toggle="{toggleScrollToPan}"></switch> </li> <li class="invert-scroll-to-pan"> <label for="invert-scroll-to-pan_checkbox">Invert scroll to pan <div class="info-container tip-container wrap-data-tip" data-tip="Invert scroll directions on this computer"> <i class="material-icons tip-trigger">info</i> </div> </label> <switch name="invert-scroll-to-pan" checked="{invertScrollChecked()}" toggle="{toggleInvertScroll}"></switch> </li> </ul> </div> </div>',
  'user-settings .material-icons,[data-is="user-settings"] .material-icons{ color: #a8a8a8; padding-right: 10px; } user-settings li,[data-is="user-settings"] li{ border-bottom: 1px solid #c6d0dd; padding: 16px 0; margin: 0 32px; display: flex; justify-content: space-between; align-items: center; } user-settings ul,[data-is="user-settings"] ul{ margin: 0px 0px 20px 0px; -webkit-margin-before:0; -webkit-margin-after:0; -webkit-margin-end:0; -webkit-margin-start:0; -webkit-padding-start:0; } user-settings .section-label,[data-is="user-settings"] .section-label{ color: #999; display: block; font-size: 12px; font-weight: 500; margin: 0 32px; } user-settings .section-label:not(:first-child),[data-is="user-settings"] .section-label:not(:first-child){ padding-top: 20px; } user-settings .tip-container,[data-is="user-settings"] .tip-container{ display: inline; } user-settings i.tip-trigger,[data-is="user-settings"] i.tip-trigger{ opacity: 0.8; font-size: 18px; } user-settings .background-color_container,[data-is="user-settings"] .background-color_container{ display: flex; justify-content: space-between; } user-settings .color-swatch,[data-is="user-settings"] .color-swatch{ height: 30px; width: 30px; border-radius: 100%; border: 2px solid #e6ebf1; margin-left: 6px; cursor: pointer; } user-settings .color-swatch:hover,[data-is="user-settings"] .color-swatch:hover{ border: 2px solid #c6d0dd; } user-settings .color-swatch.selected,[data-is="user-settings"] .color-swatch.selected{ border: 2px solid #0077f1; }',
  '', function(opts) {
'use strict';

var _this = this;

var _zoomUi = require('lib/zoom-ui');

var _opts = opts,
    canvas = _opts.canvas;
var operation = canvas.operation;

var callSettingsApi = function callSettingsApi(data) {
  $.ajax({
    method: 'POST',
    url: '/api/users/settings/update',
    data: data
  });
};

canvas.userSettingsTag = this;

this.toggleLibrary = function (libraryId) {
  return function () {
    if (!window.user) {
      return;
    }
    if (window.user.settings.allowedLibraries.includes(libraryId)) {
      window.user.settings.allowedLibraries = window.user.settings.allowedLibraries.filter(function (x) {
        return x !== libraryId;
      });
      callSettingsApi({ type: 'library', libraryId: libraryId, status: false });
    } else {
      window.user.settings.allowedLibraries.push(libraryId);
      callSettingsApi({ type: 'library', libraryId: libraryId, status: true });
    }
  };
};

this.toggleSpellcheck = function () {
  if (!window.user) {
    return;
  }
  window.user.settings.spellcheck = window.user.settings.spellcheck === 0 ? 1 : 0;
  callSettingsApi({ type: 'spellcheck', spellcheck: window.user.settings.spellcheck });
  for (var _iterator = Object.values(canvas.nodeTags), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var node = _ref;

    node.update({ forceUpdate: true });
  }
};

this.toggleSemanticZoom = function () {
  if (!window.user) {
    return;
  }
  window.user.settings.semantic_zoom = window.user.settings.semantic_zoom === 0 ? 1 : 0;
  callSettingsApi({ type: 'semantic_zoom', semantic_zoom: window.user.settings.semantic_zoom });
  if (window.user.settings.semantic_zoom) {
    _zoomUi.zoomUI.enableSemanticZoom();
  } else {
    _zoomUi.zoomUI.disableSemanticZoom();
  }
};

this.toggleScrollToPan = function () {
  var pointer = canvas.pointer;

  var newPointer = pointer === 'mouse' ? 'trackpad' : 'mouse';

  localStorage.setItem('pointer-type', newPointer);

  canvas.pointer = newPointer;
  canvas.navigationSwitcher.update();
};

this.scrollToPanChecked = function () {
  var pointer = canvas.pointer || localStorage.getItem('pointer-type') || 'mouse';

  if (pointer === 'trackpad') {
    return 'checked';
  } else {
    return false;
  }
};

this.invertScrollChecked = function () {
  var invert = canvas.invertScroll;

  if (invert === true) {
    return 'checked';
  } else {
    return false;
  }
};

this.toggleInvertScroll = function () {
  var invert = canvas.invertScroll;
  var newInvert = !invert;
  localStorage.setItem('invert-scroll', newInvert);
  canvas.invertScroll = newInvert;
};

this.handleColorClick = function (color) {
  canvas.store.setBackgroundColor(color);
  window.user.settings.background_color = color;
  callSettingsApi({ type: 'background_color', background_color: window.user.settings.background_color });

  _this.update();
  canvas.updateBackgroundColor();
};

this.selectedBgColorClass = function (color) {
  var currentBgColor = canvas.store.getBackgroundColor();

  if (!currentBgColor && color == 'gray1') {
    return 'selected';
  }

  if (currentBgColor == color) {
    return 'selected';
  }

  return '';
};

this.showTipsChecked = function () {
  if (!window.user) return false;
  return !Boolean(window.user.hide_loading_tips);
};

this.toggleShowTips = function () {
  var showTips = Boolean(window.user.hide_loading_tips);
  var newShowTips = !showTips;
  $.ajax({
    method: 'POST',
    url: '/api/users/display-flags/update',
    data: { hide_loading_tips: newShowTips ? 1 : 0 },
    success: function success() {
      return window.user.hide_loading_tips = newShowTips;
    }
  });
};

this.handleScroll = function (e) {
  // this is necessary I guess
  e.stopImmediatePropagation();
  e.stopPropagation();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('user-settings')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/user-settings.html
// module id = 593
// module chunks = 0